<template>
  <div class="">
    <div class="line1">
      <img :src="'https://yunzhixuanpro.fw366.cn/'+userInfo.avatar_img"><span>{{userInfo.nickname}}</span>
    </div>
    <!-- <div class="line2 flex" @click="tixian">
      <div> 余额：<span>---</span>元</div><button class="tixian">提现</button>
    </div> -->
    <ul>
      <li class="flex" :class="activeIndex=='/personalCenter'?'active':''" @click='goUrl("/personalCenter",1)'>
        <span id="bg" :class="activeIndex=='/personalCenter'?'bg1':'bg'"></span>
        <span class="biaoti">个人资料</span>
      </li>
      <li class="flex " @click='goUrl("/focusSchool",1)' :class="activeIndex=='/focusSchool'?'active':''">
        <span id="bg" :class="activeIndex=='/focusSchool'?'bg22':'bg2'"></span>
        <span class="biaoti" @click="goUrl('/focusSchool',3)">关注院校</span>
      </li>
      <!-- <li class="flex" @click='goUrl("/focusSchool",1)' :class="activeIndex=='/focusSchool'?'active':''">
        <span class="bg"></span>
        <span class="biaoti">我的志愿单</span>
      </li> -->
      <li class="flex " :class="activeIndex=='/focusProfessional'?'active':''">
        <span id="bg" :class="activeIndex=='/focusProfessional'?'bg22':'bg2'"></span>
        <span class="biaoti" @click="goUrl('/focusProfessional',3)">关注专业</span>
      </li>
      <li class="flex " :class="activeIndex=='/myvol'?'active':''">
        <span id="bg" :class="activeIndex=='/myvol'?'bg44':'bg4'"></span>
        <span class="biaoti" @click="goUrl('/myvol',3)">我的志愿</span>
      </li>
      <li class="flex " :class="activeIndex=='/yuyue'?'active':''">
        <span id="bg" :class="activeIndex=='/yuyue'?'bg55':'bg5'"></span>
        <span class="biaoti" @click="goUrl('/yuyue',3)">我的预约</span>
      </li>
      <li class="flex " :class="activeIndex=='/growthRecord'?'active':''">
        <span id="bg" :class="activeIndex=='/growthRecord'?'bg55':'bg5'"></span>
        <span class="biaoti" @click="goUrl('/growthRecord',3)">成长记录</span>
      </li>
      <li class="flex" :class="activeIndex=='/switchLogin'?'active':''" @click='goUrl("/switchLogin",1)'
        v-show="teacher_show=='true'">
        <span id="bg" :class="activeIndex=='/switchLogin'?'bg1':'bg'"></span>
        <span class="biaoti">切换账号</span>
      </li>
      <li class="flex" :class="activeIndex=='/myBill'?'active':''" @click='goUrl("/myBill",1)'>
        <span id="bg" :class="activeIndex=='/myBill'?'bg1':'bg'"></span>
        <span class="biaoti">分享佣金</span>
      </li>
      <li class="flex" :class="activeIndex=='/myWater'?'active':''" @click='goUrl("/myWater",1)'
        v-show="admin_show=='true'">
        <span id="bg" :class="activeIndex=='/myWater'?'bg1':'bg'"></span>
        <span class="biaoti">销售佣金</span>
      </li>
      <li class="flex" :class="activeIndex=='/teacherIntentionList'?'active':''"
        @click='goUrl("/teacherIntentionList",1)' v-show="teacher_show=='true'">
        <span id="bg" :class="activeIndex=='/teacherIntentionList'?'bg44':'bg4'"></span>
        <span class="biaoti">志愿列表</span>
      </li>
      <!--      <li class="flex " @click="goUrl('/feedback',3)" :class="activeIndex=='/feedback'?'active':''">
        <span id="bg" :class="activeIndex=='/feedback'?'bg66':'bg6'"></span>
        <span class="biaoti">意见反馈</span>
      </li>
      <li class="flex">
        <span id="bg" :class="activeIndex=='/down'?'bg77':'bg7'"></span>
        <span class="biaoti">下载APP</span>
      </li> -->
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: '/personalCenter',
        userInfo: JSON.parse(localStorage.getItem('userInfo')),
        teacher_show: false,
        admin_show: false
      }
    },

    created() {
      if (localStorage.getItem('userInfo')) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      }

      if (localStorage.getItem('admin_show')) {
        this.admin_show = localStorage.getItem('admin_show')
      }
      if (localStorage.getItem('activeurl')) {
        this.activeIndex = localStorage.getItem('activeurl')
      } else {
        this.activeIndex = '/personalCenter'
      }
      // this.userInfo.avatar_img = this.$imgUrl + this.userInfo.avatar_img
      if (localStorage.getItem('teacher_show')) {
        this.teacher_show = localStorage.getItem('teacher_show')
      }

    },
    mounted() {
      // console.log(this.$route.path)
    },
    methods: {
      goUrl(url, num) {
        this.activeIndex = url
        localStorage.setItem('activeurl', url)
        this.$router.push({
          path: url
        })
      },
      tixian() {
        this.$message.warning('暂未开放此功能')
      }
    }
  }
</script>

<style scoped lang="scss">
  ul {

    li {
      height: 50px;
      cursor: pointer;
    }
  }

  #bg {
    width: 20px;
    height: 20px;
    margin-left: 15px;
  }

  .bg {
    width: 20px;
    height: 20px;
    background: url('../../assets/me/center.png')no-repeat;
    margin-left: 15px;
  }

  .bg1 {
    width: 20px;
    height: 20px;
    background: url('../../assets/me/center1.png')no-repeat;
    margin-left: 15px;
  }

  .bg2 {
    background: url('../../assets/me/collect.png')no-repeat;
  }

  .bg22 {
    background: url('../../assets/me/collect1.png')no-repeat;
  }


  .bg4 {
    background: url('../../assets/me/form.png')no-repeat;
  }

  .bg44 {
    background: url('../../assets/me/form1.png')no-repeat;
  }

  .bg5 {
    background: url('../../assets/me/yuyue.png')no-repeat;
  }

  .bg55 {
    background: url('../../assets/me/yuyue1.png')no-repeat;
  }

  .bg6 {
    background: url('../../assets/me/feedback.png')no-repeat;
  }

  .bg66 {
    background: url('../../assets/me/feedback1.png')no-repeat;
  }

  .bg7 {
    background: url('../../assets/me/down.png')no-repeat;
  }

  .bg77 {
    background: url('../../assets/me/down1.png')no-repeat;
  }

  .active {
    background-color: #E8FAFA;
    color: #19CACA;
  }

  .biaoti {
    margin-left: 10px;
  }

  .left {
    width: 283px;
    // height: 692px;
    border: 1px solid #EDEDED;
    border-radius: 4px;

    .tixian {
      width: 70px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      color: #FFFFFF;
    }

    .line2 {
      margin: 45px 32px 25px 32px;
      justify-content: space-between;

      span {
        color: #F9D681;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #F9D681;
      }
    }

    .line1 {
      margin: 27px 0;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;

      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        margin-right: 11px;
        border-radius: 50%;
      }
    }
  }

  .el-menu-vertical-demo {
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/me/centerleft.vue